module.exports = __webpack_public_path__ + "static/media/lectra.52721efd.png";